<template>
    <div v-if="['A','D'].find(el=>el==store.state.user.groupe)">
    <!-- v-if="['A','D'].find(el=>el==store.state.user.groupe)" -->
         <v-navigation-drawer >
        <v-card>
            <v-list-item title="Liste de Commandes" subtitle="Fournisseur"></v-list-item>
            <v-row style="margin-top: 20px">
                <v-col style="margin-left: 20px">
                    <v-btn density="compact" v-if="['A'].find(el=>el==store.state.user.groupe)" @click="getAchat()" color="primary" ><v-icon icon="mdi-refresh"></v-icon></v-btn>   
                </v-col>
                <v-col >
                    <v-btn density="compact" v-if="store.state.user.username=='m.benhamada'" @click="importExport()" color="grey" ><v-icon icon="mdi-database-export-outline"></v-icon></v-btn>   
                </v-col>
            </v-row>
            <v-row>
                <v-col style="margin: 10px;margin-top: -10px">
                    <v-combobox
                    clearable
                    label="Saison"
                    :items="filtreCommandesItems.saison"
                    v-model="filtreCommandes.saison"
                    variant="outlined"
                    density="compact"
                    style="margin: 10px;margin-top: 10px"
                    ></v-combobox>
                </v-col>
                
            </v-row>
            <v-row>
                <v-col style="margin: 10px;margin-top: -20px">
                    <v-combobox
                    clearable
                    label="Fournisseur"
                    :items="filtreCommandesItems.fournisseur"
                    v-model="filtreCommandes.fournisseur"
                    variant="outlined"
                    density="compact"
                    style="margin: 10px;margin-top: -20px"
                    ></v-combobox>

                </v-col>
                
            </v-row>
            <v-row>
                <v-col style="margin: 10px;margin-top: -20px">
                    <v-combobox
                    clearable
                    label="Marque"
                    :items="filtreCommandesItems.marque"
                    v-model="filtreCommandes.marque"
                    variant="outlined"
                    density="compact"
                    style="margin: 10px;margin-top: -20px"
                    ></v-combobox>
                </v-col>
                
            </v-row>
            <v-row >
                <v-col style="margin: 10px;margin-top: -20px">
                    <v-text-field
                    v-model="filtreCommandes.rechercher"
                    label="Rechercher"
                    variant="outlined"
                    density="compact"
                    style="margin: 10px;margin-top: -20px"
                    ></v-text-field>
                </v-col>
                
            </v-row>
            <!-- <v-row > -->
                <!-- <v-checkbox label="Encours"   style="margin-left: 1em;"></v-checkbox>
                <v-checkbox label="Expédié"  ></v-checkbox>  -->
                <!-- <div  class="input-group input-group-sm mb-3" style="margin:20px;">
                    <button style="width: 50px;" @click="getCommandeFournisseur(numcommande,'test','test')" class="btn btn-outline-secondary" type="button" id="button-addon1">get</button>
                    <input v-model="numcommande"  class="form-control form-control-sm" type="text" >
                </div> -->
            <!-- </v-row> -->
            <!-- <v-row v-if="inProgress">
                <v-checkbox label="ATT" v-model="attente" @change="finished=false;accepted=false;denied=false;getReceptions();" style="margin-left: 1em;"></v-checkbox> 
                <v-checkbox label="OK" v-model="accepted" @change="finished=false;attente=false;denied=false;getReceptions()"></v-checkbox>
                <v-checkbox label="KO" v-model="denied" @change="finished=false;attente=false;accepted=false;getReceptions()"></v-checkbox> 
            </v-row>  -->
            
            
            <v-list style="margin-top: -50px">
                <v-divider ></v-divider>
                <v-list-item 
                    v-for="(item, i) in itemsCommandesFournFiltred"
                    :key="i"
                    :value="item.refinterne"
                    color="primary"
                    variant="plain"
                >
                <!-- (item.refinterne,item.code_marque) -->
                <button type="button" @click="getCommandeFournisseur(item.refinterne,item.code_marque)" 
                    :class="getButtonColor(item.statut)" style="width: 200px;">
                    <span>{{`${item.code_fournisseur}-${item.code_marque}-${item.refinterne}-${item.saison}` }}</span><br>
                    <!-- <span v-if="item.reception.informations" :style="[(item.reception.informations.match(/ref/gmi)||item.reception.etat.match(/ref/gmi))?{'color':'red'}:{'color':'green'}]">
                        {{ `${item.reception.informations?''+item.reception.informations:''}`}}
                    </span>  -->
                </button>
                </v-list-item>
            </v-list>
        </v-card> 
    </v-navigation-drawer>
  <div class="container" style="margin-top: 50px;" >
    
    <v-progress-linear  v-if="store.state.waiting"  color="antiquewhite" indeterminate></v-progress-linear>
    
    <!-- <v-card v-if="noOrderGetted">
        <div class="no-orders">
            <div class="no-orders__icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round">
                <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"></path>
                <path d="M3 6h18"></path>
                <path d="M16 10a4 4 0 0 1-8 0"></path>
            </svg>
            </div>
            <h3 class="no-orders__title">Aucune commande en cours</h3>
            <p class="no-orders__message">
            Vous n'avez pas de commande active pour le moment.
            </p>
        </div>
    </v-card> -->
    <v-container v-if="noOrderGetted" class="d-flex justify-center align-center" style="height: 400px;">
        
        <v-row justify="center">
        <v-col cols="12" class="text-center">
            <v-icon size="64" color="grey-lighten-1" icon="mdi-cart-off"></v-icon>
            <h3 class="text-h5 font-weight-medium mt-4">
            Aucune commande en cours
            </h3>
            <p class="text-body-1 text-grey mt-2">
            Vous n'avez pas de commande active pour le moment.
            </p>
            <!-- Optionnel : bouton pour créer une commande -->
            
        </v-col>
        </v-row>
    </v-container>
    <v-expansion-panels
      v-model="panel"
      multiple
      v-if="!noOrderGetted"
    >
      <v-expansion-panel v-for="(fabricant, code_fournisseur) in achat.articles" :key="code_fournisseur" >
        <!-- <v-expansion-panel-title  style="background-color:whitesmoke"> {{ getLibelleFournisseur(fabricant,2).acheteur }}   {{ code_fournisseur}} - {{ getLibelleFournisseur(fabricant,2).fournisseur  }}  
            <template v-slot:actions="{ expanded }">
                <span :style="[getOrderStatus(getLibelleFournisseur(fabricant,2).refinterne).color]">{{ getOrderStatus(getLibelleFournisseur(fabricant,2).refinterne).statut }}</span> 
            </template> 
            :color="getOrderStatus(getLibelleFournisseur(fabricant,2).refinterne).color"
                :text-color="getTextColor(getOrderStatus(getLibelleFournisseur(fabricant,2).refinterne).color)"
        </v-expansion-panel-title> -->
        <v-expansion-panel-title style="background-color:whitesmoke">
        {{ getLibelleFournisseur(fabricant,2).acheteur }} {{ getLibelleFournisseur(fabricant,2).code_fournisseur }} - {{ getLibelleFournisseur(fabricant,2).fournisseur }} - {{ getLibelleFournisseur(fabricant,2).marque }} - {{ getLibelleFournisseur(fabricant,2).date }}
        
            <template v-slot:actions="{ expanded }">
                <v-chip
                :style="[getOrderStatus(getLibelleFournisseur(fabricant,2).refinterne).color]"
                
                size="small"
                class="ml-2"
                >
                {{ getOrderStatus(getLibelleFournisseur(fabricant,2).refinterne).statut }}
                </v-chip>
            </template>
        </v-expansion-panel-title>
        <v-expansion-panel-text>
            <v-card class="glass-card pa-4" elevation="16">  
                <div style="overflow-y: auto;max-height: 700px;min-height: 300px;" class="container">
                    <div v-for="(marque,code_marque) in fabricant " :key="code_marque" class="upload-card">  
                        <v-card >
                            <div >
                                <table>
                                    <tbody>
                                        <tr>
                                            <th width="100" style="background-color:#FFF4D7">marque :</th>
                                            <th width="200" style="background-color:#FFF4D7">{{getLibelleFournisseur(fabricant,2).marque  }}</th>
                                            <th width="100" style="background-color:#FFF4D7">Code marque :</th>
                                            <th width="100" style="background-color:#FFF4D7">{{ getLibelleFournisseur(fabricant,2).code_marque }}</th>
                                            <th width="100" style="background-color:#FFF4D7">Qté marque :</th>
                                            <th width="100" style="background-color:#FFF4D7">{{totalmarque(marque).qte }}</th>
                                            <th width="100" style="background-color:#FFF4D7">Total HT marque :</th>
                                            <th width="100" style="background-color:#FFF4D7">{{totalmarque(marque).totalht}} €</th>
                                            <th width="200" style="background-color:#FFF4D7">Total HT Remisé marque :</th>
                                            <th width="100" style="background-color:#FFF4D7">{{totalmarque(marque).totalhtremise}} €</th>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        <div  v-for="theme in marque">
                            <div >
                                <table>
                                    <tbody>
                                        <tr>
                                            <th width="100" style="background-color:#FFF4D7"> <span><v-icon class="iconAdd" :disabled="addArticles" icon="mdi-plus" @click="store.state.marque=theme[Object.keys(theme)[0]][Object.keys(theme[Object.keys(theme)[0]])[0]].code_marque;dialogAjout=true;fournisseur=theme[Object.keys(theme)[0]][Object.keys(theme[Object.keys(theme)[0]])[0]].refinterne;selectArticle()"></v-icon></span>Thème : </th>
                                            <th width="200" style="background-color:#FFF4D7">{{theme[Object.keys(theme)[0]][Object.keys(theme[Object.keys(theme)[0]])[0]].theme}} </th>
                                            <th width="100" style="background-color:#FFF4D7">Code Thème :</th>
                                            <th width="100" style="background-color:#FFF4D7">{{theme[Object.keys(theme)[0]][Object.keys(theme[Object.keys(theme)[0]])[0]].code_theme}}</th>
                                            <th width="100" style="background-color:#FFF4D7">Qté Thème :</th>
                                            <th width="100" style="background-color:#FFF4D7">{{ totalTheme(theme).qte  }}</th>
                                            <th width="100" style="background-color:#FFF4D7">Total HT Thème : </th>
                                            <th width="100" style="background-color:#FFF4D7">{{ totalTheme(theme).totalht }} €</th>
                                            <th width="200" style="background-color:#FFF4D7">Total HT Remisé Thème : </th>
                                            <th width="100" style="background-color:#FFF4D7">{{ totalTheme(theme).totalhtremise }} €</th>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div  v-for="refs in theme" >
                                <table  >
                                    <tbody style="border: 0.1em  solid;">
                                        <tr>
                                            <th width="150"  style="border: 0.1em  solid;background-color:#DDE2ED;">Nom Produit</th>
                                            <th width="50" colspan="1" style="border: 0.1em  solid;background-color:#DDE2ED;" class="iconAdd" >Réf AD INT</th>
                                            <th  width="50" style="border: 0.1em  solid;background-color:#DDE2ED;">Rayon</th>
                                            <th width="50" style="border: 0.1em  solid;background-color:#DDE2ED;">S-Famille</th>
                                            <th width="50" style="border: 0.1em  solid;background-color:#DDE2ED;">Saison</th>
                                            <th :colspan="store.state.dateLivraisons.length+1" style="overflow-y: auto;border: 0.1em  solid;background-color:#DDE2ED;" width="50">Désignation</th>
                                            <th width="100" style="border: 0.1em  solid;background-color:#DDE2ED;" colspan="2">
                                                Repartition
                                            </th>
                                            <th width="100" style="border: 0.1em  solid;background-color:#DDE2ED;">Fournisseur:</th>
                                            <th width="100" style="border: 0.1em  solid;background-color:#DDE2ED;">Composition:</th>
                                            <th width="100" colspan="2" style="border: 0.1em  solid;background-color:#DDE2ED;">Désig. Compl.</th>
                                        </tr>
                                        <tr> 
                                            <th width="100" style="border: 0.1em   solid;background-color:#DDE2ED;" >{{refs[Object.keys(refs)[0]].ref_fourn}}</th>
                                            <th width="100" colspan="1" style="border: 0.1em  solid;background-color:#DDE2ED;"><v-icon :disabled="addArticles" @click="store.state.marque=refs[Object.keys(refs)[0]].code_marque;dialogAjout=true;fournisseur=refs[Object.keys(refs)[0]].refinterne;articleRef=refs[Object.keys(refs)[0]];selectArticle(refs[Object.keys(refs)[0]].code_theme,null,refs[Object.keys(refs)[0]].refinterne)" class="iconAdd" icon="mdi-plus" ></v-icon>{{refs[Object.keys(refs)[0]].codearticle  }}</th>
                                            <th width="50" style="border: 0.1em  solid;background-color:#DDE2ED;">{{ refs[Object.keys(refs)[0]].code_rayon }}
                                            </th>
                                            <th width="50" style="border: 0.1em  solid;background-color:#DDE2ED;">{{ refs[Object.keys(refs)[0]].code_sousfamille }}
                                            </th>
                                            <th width="50" style="border: 0.1em  solid;background-color:#DDE2ED;">
                                                <select name="collections" id="collections" v-model="refs[Object.keys(refs)[0]].saison" >
                                                    <option  v-for="key in collections">{{key}}</option>
                                                </select>    
                                            </th>
                                            <th :colspan="store.state.dateLivraisons.length+1" style="border: 0.1em  solid;background-color:#DDE2ED;max-width: 200;" width="50"><input v-model="refs[Object.keys(refs)[0]].designation"></th>
                                            <th width="100"  style="max-width: 100px; ;border: 0.1em  solid;background-color:#DDE2ED; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"  colspan="2" @click="repartDialog=true;articleRepart={type:'ref',art:refs[Object.keys(refs)[0]]}">
                                                <table border="1">
                                                    <tbody>
                                                        <tr>
                                                            <td style="max-width: 200px; padding: 0;">
                                                            <div style="overflow-x: auto; white-space: nowrap; max-width: 200px;">
                                                            {{ repartLigne(refs[Object.keys(refs)[0]].repart) }}
                                                            </div>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </th>
                                            <th width="100" style="border: 0.1em  solid;background-color:#DDE2ED;">{{ refs[Object.keys(refs)[0]].code_fournisseur }}</th>
                                            <th width="100" style="border: 0.1em  solid;background-color:#DDE2ED;">{{ refs[Object.keys(refs)[0]].composition }}</th>
                                            <th width="100" colspan="2" style="border: 0.1em  solid;background-color:#DDE2ED;">{{ refs[Object.keys(refs)[0]].designation }}</th>
                                        </tr>
                                        <tr>
                                            <th width="100"  style="border: 0.1em solid; background-color:#E6F3E6;">Image
                                            </th>
                                            <th width="50" :colspan="refs[Object.keys(refs)[0]].taille?0:3"  style="border: 0.1em  solid; background-color:#E6F3E6;"  ><v-icon class="iconAdd" @click="store.state.marque=refs[Object.keys(refs)[0]].code_marque;dialogAjout=true;fournisseur=refs[Object.keys(refs)[0]].refinterne;articleRef=refs[Object.keys(refs)[0]];selectArticle(refs[Object.keys(refs)[0]].code_theme,refs[Object.keys(refs)[0]].codearticle,refs[Object.keys(refs)[0]].refinterne)" :disabled="addArticles"  icon="mdi-plus" ></v-icon>couleur </th>
                                            <th v-if="refs[Object.keys(refs)[0]].taille" width="50" style="border: 0.1em  solid; background-color:#E6F3E6;">taille</th>
                                            <th v-if="refs[Object.keys(refs)[0]].taille" width="50" style="border: 0.1em  solid; background-color:#E6F3E6;">T. Fourn</th>
                                            <th width="50" style="border: 0.1em  solid; background-color:#E6F3E6;">Repart</th>
                                            <th width="50" style="border: 0.1em  solid; background-color:#E6F3E6;">Stock DEPO</th>
                                            <th width="50" style="border: 0.1em  solid; background-color:#E6F3E6;">Qte</th>
                                            <th width="100" style="border: 0.1em  solid; background-color:#E6F3E6;">Prix Achat HT</th>
                                            <th width="100" style="border: 0.1em  solid; background-color:#E6F3E6;">Remise ligne</th>
                                            <th width="100" style="border: 0.1em  solid; background-color:#E6F3E6;">Prix de revient</th>
                                            <th width="100" style="border: 0.1em  solid; background-color:#E6F3E6;">Prix Public</th>
                                            <th width="100" style="border: 0.1em  solid; background-color:#E6F3E6;">TTC Prix Promo</th>
                                            <th width="100" style="border: 0.1em  solid; background-color:#E6F3E6;">Total Achat HT</th>
                                        </tr>
                                        <tr >
                                            <th  :rowspan="Object.keys(refs).length+2" valign="top" style="border: 0.1em  solid;background-color:#B0C4E9;" width="100">
                                                <img style="border: 1px solid grey;padding: 1px;"  @click="imageDialog=true;srcImage=`https://www.edisac.com/images/article_la/${refs[Object.keys(refs)[0]].imagename}`" v-if="refs[Object.keys(refs)[0]].imagename" :src="`https://www.edisac.com/images/article_la/${refs[Object.keys(refs)[0]].imagename}`"  width="100px" height="70px">
                                            </th>
                                            <th :colspan="refs[Object.keys(refs)[0]].taille?'':3" width="100"  style="background-color:#B0C4E9;max-height: 10px;" >{{ getColorNumber(refs).color }}</th>
                                            <th v-if="refs[Object.keys(refs)[0]].taille" width="50" style="border: 0.1em  solid;background-color:#B0C4E9;">{{getColorNumber(refs).taille}}</th>
                                            <th v-if="refs[Object.keys(refs)[0]].taille" width="50" style="border: 0.1em  solid;background-color:#B0C4E9;">T. Fourn</th>
                                            <th width="50" style="border: 0.1em  solid; background-color:#B0C4E9;">Repart</th>
                                            <th width="50" style="border: 0.1em  solid;background-color:#B0C4E9;">{{ totalRef(refs).qteStock }}</th>
                                            <th width="50" style="border: 0.1em  solid;background-color:#B0C4E9;">{{ totalRef(refs).qte }}</th>
                                            <td width="100" style="border: 0.1em  solid;background-color:#B0C4E9;"><input :disabled="refs[Object.keys(refs)[0]].termine" size="6" v-model="refs[Object.keys(refs)[0]].achat_euro"></td>
                                            <td width="100" style="border: 0.1em  solid;background-color:#B0C4E9;"><input :disabled="refs[Object.keys(refs)[0]].termine" size="6" v-model="refs[Object.keys(refs)[0]].remise"><span >%</span></td>
                                            <td width="100" style="border: 0.1em  solid;background-color:#B0C4E9;">{{((1-refs[Object.keys(refs)[0]].remise_pied/100)*(1-refs[Object.keys(refs)[0]].remise_ligne/100)*refs[Object.keys(refs)[0]].achat_euro).toFixed(2) }}</td>
                                            <td width="100" style="border: 0.1em  solid;background-color:#B0C4E9;"><input :disabled="refs[Object.keys(refs)[0]].termine" size="6" v-model="refs[Object.keys(refs)[0]].vte_euro"></td>
                                            <td width="100" style="border: 0.1em  solid;background-color:#B0C4E9;"><input :disabled="refs[Object.keys(refs)[0]].termine" size="6" v-model="refs[Object.keys(refs)[0]].promo.promo"></td>
                                            <td width="100" style="border: 0.1em  solid;background-color:#B0C4E9;">{{ totalRef(refs).totalhtremise }}</td>
                                        </tr>
                                        <tr v-for="article in refs" >
                                            <td width="100"  :colspan="refs[Object.keys(refs)[0]].taille?0:3" style="border: 0.1em  solid;"><span>{{`${article.code_couleur}-${article.couleur}`}}</span></td>
                                            <td v-if="refs[Object.keys(refs)[0]].taille" width="50"  style="border: 0.1em  solid;" >{{article.taille}}</td>
                                            <td v-if="refs[Object.keys(refs)[0]].taille" width="50" style="border: 0.1em  solid;" >{{article.taille}}</td>
                                            <td width="50" class="iconAdd" style="border: 0.1em  solid;" @click="articleRepart={type:'color',art:article};getRepart(article)">Repart</td>
                                            <td width="50" class="iconAdd" style="border: 0.1em  solid;" @click="articleStock={art:article};getReliquat(article);">{{ article.stock_DEPO }}</td>
                                            <td width="50" style="border: 0.1em  solid;" @dblclick="getStatsReliquat(article)"><input :disabled="article.termine" min="0" size="6" style="width: 70%;" type="number" v-model="article.qte_commande"></td>
                                            <td widtd="100" style="border: 0.1em  solid;"><input :disabled="article.termine" min="0" size="6" style="width: 70%;" type="number" v-model="article.achat_euro"><span >€</span></td>
                                            <td widtd="100" style="border: 0.1em  solid;"><input :disabled="article.termine" min="0" size="6" style="width: 70%;" type="number" v-model="article.remise_ligne"><span >%</span></td>
                                            <td widtd="100" style="border: 0.1em  solid;">{{ ((article.frais_port&&totalCommande(fabricant).qte!=0?article.frais_port/totalmarque(marque).qte:0)+(1-article.remise_pied/100)*(1-article.remise_ligne/100)*article.achat_euro).toFixed(2) }}</td>
                                            <td widtd="100" style="border: 0.1em  solid;"><input :disabled="article.termine" min="0" size="6" style="width: 70%;" type="number" v-model="article.vte_euro"><span >€</span></td>
                                            <td width="100" style="border: 0.1em  solid;"><input :disabled="article.termine" min="0" size="6" style="width: 70%;" type="number" v-model="article.promo.promo"><span >€</span></td>
                                            <td width="100" style="border: 0.1em  solid;"><input :disabled="article.termine" min="0" step="2" size="6" disabled style="width: 70%;" type="number" :value="((1-article.remise_ligne/100)*article.qte_commande*article.achat_euro).toFixed(2)"><span >€</span></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <v-divider class="border-opacity-25"></v-divider>
                        </div>
                        </v-card>
                        <v-card class="transparent-component">
                            <div class="card p-3 shadow-sm" >
                            <div class="row">
                            <div class="col-12 col-md-8 mb-4" >
                                <div class="chart-container border rounded p-3 bg-light" @click="dataChart=chartData(marque);statDialog=true">
                                <Pie :data="chartData(marque)" :options="chartOptions" />
                                </div>
                            </div>
                            <div class="col-12 col-md-4" >
                                <table class="table table-sm align-middle">
                                    <tbody>
                                        <tr class="table-active">
                                        <td><strong>Total Quantités:</strong></td>
                                        <td class="text-end" >
                                            <input 
                                            disabled
                                            type="number"
                                            class="form-control form-control-sm fs-6 w-75 text-end"
                                            v-model.number="totalCommande(fabricant).qte"
                                            />
                                        </td>
                                        </tr>
                                        <tr>
                                        <td><strong>Total CDE HT:</strong></td>
                                        <td class="text-end">
                                            <div class="input-group input-group-sm w-75">
                                            <input :disabled="getLibelleFournisseur(fabricant,2).termine"
                                                type="number"
                                                class="form-control fs-6 text-end"
                                                v-model.number="totalCommande(fabricant).totalht"
                                            />
                                            <span class="input-group-text">€</span>
                                            </div>
                                        </td>
                                        </tr>
                                        <tr>
                                        <td><strong>Frais de Port:</strong></td>
                                        <td class="text-end">
                                            <div class="input-group input-group-sm w-75">
                                            <input
                                                :disabled="getLibelleFournisseur(fabricant,2).termine"
                                                type="number"
                                                class="form-control fs-6 text-end"
                                                placeholder="0"
                                                @change="updateFraisPortRemise(fabricant, $event, 'frais_port')"
                                            />
                                            <span class="input-group-text">€</span>
                                            </div>
                                        </td>
                                        </tr>

                                        <tr>
                                        <td><strong>Remise Pied 1:</strong></td>
                                        <td class="text-end">
                                            <div class="input-group input-group-sm w-75">
                                            <input 
                                                :disabled="getLibelleFournisseur(fabricant,2).termine"
                                                type="number"
                                                class="form-control fs-6 text-end"
                                                placeholder="0"
                                                v-model="getLibelleFournisseur(fabricant,2).remise_pied"
                                                @change="updateFraisPortRemise(fabricant, $event, 'remise_pied')"
                                            />
                                            <span class="input-group-text">%</span>
                                            </div>
                                        </td>
                                        </tr>

                                        <tr class="table-active">
                                        <td><strong>Total Final:</strong></td>
                                        <td class="text-end">
                                            <div class="input-group input-group-sm w-75">
                                            <input
                                                disabled
                                                type="number"
                                                class="form-control fs-6 text-end"
                                                v-model.number="totalCommande(fabricant).totalhtremise"
                                            />
                                            <span class="input-group-text">€</span>
                                            </div>
                                        </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            </div>
                        </div>
                    </v-card>
                </div>
                </div>
                
                <v-card class="actions-card">
                    <v-card-actions class="justify-center">
                        <v-btn color="success" size="large"  
                        :disabled="getLibelleFournisseur(fabricant,2).termine&&store.state.user.username!='m.benhamada'"
                        :loading="loading" 
                        @click="fabricantToValidate=fabricant;authentification=true" 
                        >
                        <v-icon icon="mdi-check" class="mr-2"></v-icon>
                            Valider la Commande
                        </v-btn>

                        <v-btn color="info" size="large"  class="ml-4" @click="exportToExcel(fabricant)">
                        <v-icon icon="mdi-export" class="mr-2"></v-icon>
                            Exporter
                        </v-btn>
                        <!-- <v-btn 
                            color="primary" 
                            @click="showComposer = true"
                            prepend-icon="mdi-email">
                            Nouvel email
                        </v-btn> -->
                    </v-card-actions>
                </v-card>
            </v-card>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
  <div class="text-center pa-4">
      <v-dialog
        v-model="repartDialog"
        width="auto"
      >
        <v-card
          max-width="400"
          prepend-icon="mdi-book-edit"
          :text="`${articleRepart.type=='color'?'Modification de la répartition couleur ':'Modification de la répartition de la référence '}`"
          title="Répartition"
        >
            <v-card style="overflow-y: auto;">
                <v-container class="bg-lightblue py-6" style="max-width: 500px;" >
                    <v-card elevation="2" class="pa-4" >
                    <v-card-title class="text-subtitle-1"></v-card-title>
                        <v-row dense>
                            <v-col cols="3" v-for="etab in fields">
                                <v-text-field
                                    :label="etab.code"
                                    v-model="etab.value"
                                    variant="outlined"
                                    density="compact"
                                    hide-details
                                    class="field"
                                />
                                <!-- v-model="articleRepart.art.repart[etab.code]" -->
                            </v-col>
                        </v-row>
                    </v-card>
                </v-container>
            </v-card>
          <template v-slot:actions>

            <v-card-actions >
                <v-btn
                    text="Fermer"
                    @click="repartDialog = false"
                    variant="plain"
                    color="red"
                ></v-btn>
                
                <v-btn 
                    color="success"
                    text="Valider"
                    @click="setRepart();repartDialog = false"
                    variant="plain"
                ></v-btn>
                
            </v-card-actions>  
          </template>
        </v-card>
      </v-dialog>
    </div>
    <div class="text-center pa-4">
      <v-dialog
        v-model="stockDialog"
        width="auto"
      >
        <v-card
          max-width="400"
          prepend-icon="mdi-store"
          text="Stock"
          title="Stock par magasin"
        >
            <v-card style="overflow-y: auto;">
                <v-container class="bg-lightblue py-6" style="max-width: 500px;" >
                    <v-card elevation="2" class="pa-4" >
                    <v-card-title class="text-subtitle-1"></v-card-title>
                        <v-row dense>
                            <v-col cols="3" v-for="etab in fieldsStock">
                                <v-text-field 
                                    :style="[articleStock.art.stock[etab.code]>0?{'color':'green'}:'']"
                                    :label="etab.code"
                                    v-model="articleStock.art.stock[etab.code]"
                                    variant="outlined"
                                    density="compact"
                                    hide-details
                                    class="field"
                                />
                            </v-col>
                        </v-row>
                    </v-card>
                </v-container>
            </v-card>
          <template v-slot:actions>

            <v-card-actions >
                <v-btn
                    text="Fermer"
                    @click="stockDialog = false"
                    variant="plain"
                    color="red"
                ></v-btn>
            </v-card-actions>  
          </template>
        </v-card>
      </v-dialog>
    </div>
    <div class="text-center pa-4">
      <v-dialog
        v-model="imageDialog"
        width="600"
      >
        <v-card width="600">
            <v-img
                width="600"
                cover
                :src="srcImage"
            ></v-img>
        </v-card>
      </v-dialog>
    </div>

    <div class="text-center pa-4">
      <v-dialog
        v-model="statDialog"
        width="700"
      >
        <v-card>
            <Pie   :data="dataChart" :options="chartOptions" />
        </v-card>
      </v-dialog>
    </div>
    <div class="text-center pa-4">
      <v-dialog
        v-model="showComposer"
        width="700"
      >
        <v-card>
            <EmailComposer 
                @close="showComposer = false"
                @sent="handleEmailSent"
                />
        </v-card>
      </v-dialog>
    </div>
    <div class="text-center pa-4">
      <v-dialog
          v-model="authentification"
          width="auto"
      >
        <v-card
          max-width="400"
          prepend-icon="mdi-account-check"
          text="Veuillez saisir votre mot de passe"
          title="Vérification"
          >
          <v-spacer></v-spacer>
          <v-card-actions >
            <input 
            type="text" class="form-control" placeholder="mot de passe" aria-label="mot de passe" aria-describedby="basic-addon2" v-model="mdpSaisie">
            <v-btn
            text="Annuler"
            @click="authentification = false"
            color="warning"
            ></v-btn>
            <v-btn
            text="Valider"
            @click="checkingLogIn()"
            :disabled="mdpSaisie!=''?false:true"
            color="success"
            ></v-btn>
            
            </v-card-actions>
            <small v-if="message" style="color:red;margin-left: 0.5em;text-align: center;" >{{message}}</small>
          </v-card>
      </v-dialog>
    </div>
  <div  class="text-center" >
      <v-dialog  v-model="dialogAjout" width="auto" >
        <v-card  prepend-icon="mdi-plus" 
        :text="tab=='art'?`Veulliez saisir l'article à ajouter`:(tab=='three'?`Veulliez choisir le thème à ajouter`:(tab=='two'?`Veulliez choisir la référence à ajouter`:`Veuillez saisir la qté de chaque couleur`))"
        title="Ajout Articles"
        >
        <v-card>
            <v-card-text >
                <div v-if="tab=='art'" class="input-group input-group-sm mb-3">
                    <input size="5"  v-model="rechercherArticle"  class="form-control form-control-sm" type="text" :style="[rechercherArticleStatut.statut?{'color':'red'}:{}]"> 
                </div>
                <div v-if="tab!='art'" class="input-group input-group-sm mb-3" height="10px">
                    <input size="5"  v-model="rechercher"  class="form-control form-control-sm" type="text" >
                    <div v-if="tab=='one'">
                        <input v-model="EAN13Choice" style="margin: 0.4rem;" type="checkbox" id="scales" name="scales" checked />
                        <label style="font:1rem Fira Sans,sans-serif;" for="scales">ean13</label>
                    </div>
                </div>
                <div v-if="rechercherArticleStatut.statut" style="text-align: center;color: red;">
                    <p>{{ rechercherArticleStatut.msg }}</p>
                </div>
            <v-tabs-window v-model="tab" >
                <v-tabs-window-item value="one">
                    <v-card class="scroll-box">  
                        <table height="auto">
                            <tbody>
                                <tr v-for="color in articleToAddTabFilter" >
                                    <td  >
                                        
                                        <div class="input-group input-group-sm mb-3">
                                            <button style="width: 150px;" @click="color.qte_commande++" class="btn btn-outline-secondary" type="button" id="button-addon1">{{ `${color.taille?color.code_couleur+"-"+color.couleur+"-"+color.taille:color.code_couleur+"-"+color.couleur}` }}</button>
                                            <input  v-if="EAN13Choice" :style="[gererateEAN13(color.ean13_y2).erreur?{'color':'red','width': '120px'}:{'color':'green','width': '120px'}]" v-model="color.ean13_y2"  class="form-control form-control-sm" type="text" ></input>
                                            <input  style="width: 70px;" v-model="color.qte_commande"  min="0" class="form-control form-control-sm" type="number" ></input>
                                            <input disabled style="width: 50px;" v-model="color.stock.DEPO"  min="0" class="form-control form-control-sm" type="number" ></input>
                                            <!-- <span ><v-icon style="margin-top: 8px;margin-left: 8px;" :icon="etatStock(color).icon" size="small" :color="etatStock(color).color"></v-icon></span> -->
                                            
                                        </div>
                                        <p  v-if="EAN13Choice&&gererateEAN13(color.ean13_y2).erreur" style="color:red;height: 2px;text-align: center;">Vérifiez le code ean13</p>    
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </v-card>   
                </v-tabs-window-item>
                <v-tabs-window-item value="two" scrollable>
                   <v-card class="scroll-box">
                    <table height="auto">
                        <tbody>
                            <tr v-for="ref in articleToAddTabFilter">
                                <td  width="300" >
                                    
                                    <div class="input-group input-group-sm mb-3">
                                        <button style="width: 150px;" @click="tab='one';selectArticle(ref.theme,ref.code,null )" class="btn btn-outline-secondary" type="button" id="button-addon1">{{ ref.code  }}</button>
                                        <input disabled v-model="ref.libelle"  class="form-control form-control-sm" type="text" >
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                   </v-card> 
                </v-tabs-window-item>
                <v-tabs-window-item value="three" height="400">
                    <v-card class="scroll-box">
                        <div v-for="theme in articleToAddTabFilter" style="margin-top: 1px;">
                            <div  class="input-group input-group-sm mb-3">
                                <button style="width: 150px;" @click="tab='one';selectArticle(theme.code)" class="btn btn-outline-secondary" type="button" id="button-addon1">{{ theme.code  }}</button>
                                <input disabled="true" v-model="theme.libelle"  class="form-control form-control-sm" type="text" >
                            </div>
                        </div>
                    </v-card>
                </v-tabs-window-item>
            </v-tabs-window>
            </v-card-text>
        </v-card>
        <template v-slot:actions>
            <v-btn class="ms-auto" text="Annuler" @click="dialogAjout = false" style="text-align: left;"></v-btn>
            <v-btn v-if="tab!='art'" class="ms-auto" text="Ajouter" @click="addArticle();dialogAjout = false"></v-btn>
            <v-btn v-if="tab=='art'" class="ms-auto" text="Ajouter" @click="getArticle()"></v-btn>
        </template>
        </v-card>
      </v-dialog>
    </div> 
    </div>
    <InfosQuantities v-if="qteDialog"
        :productData="productData"
        :article="qteArticle"
        :storeOptions="storeOptions"
        :type="{type:'color'}"
        v-model="qteDialog"
    >
    </InfosQuantities>
    <div class="text-center">
        <v-dialog persistent v-model="dialogSpin" 
            max-width="600"
            width="600">
            <!-- <div :class="{'pointer-events-none': dialogSpin}">
            </div> -->
            <!-- <v-card> -->
                
                <div  class="loading-content" width="400px">
                    <v-progress-circular
                        indeterminate
                        size="64"
                        width="6"
                        color="primary"
                    />
                    <p class="mt-4 text-h6">Chargement en cours...</p>
                    <p class="text-caption">Veuillez patienter</p>
                </div>
        </v-dialog>
    </div>
</template>
<script setup>
    import { reactive, onMounted, ref, computed, watch, toRaw } from 'vue'
    import axios from 'axios'
    import store from './store'
    import * as XLSX from 'xlsx';
    import EmailComposer from './Email.vue'
    import InfosQuantities from './components/InfosQuantities.vue'
    import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    ArcElement,
    } from 'chart.js'
    import { Pie } from 'vue-chartjs'
    let message=ref()
    let dialogSpin=ref(false)
    let srcImage=ref()
    let fournisseur=ref()
    let imageDialog=ref(false)
    let commandeNotExist=ref({exist:false,numero:''})
    let statDialog=ref(false)
    let EAN13Choice=ref(false)
    let authentification=ref(false)
    let mdpSaisie=ref('')
    // let dateLivraisons=ref(["20251001"])
    let qteDialog=ref()
    let dataChart=ref()
    let stockDialog=ref(false)
    const showComposer = ref(false)
    const handleEmailSent = () => {
    showComposer.value = false
    }
    let code_marque=ref()
    
    
    watch(code_marque,()=>{
        store.commit('addmarque',code_marque.value)
    })
    
    let dupplicateDialog=ref(false)

    let fields = ref([
        { code: 'MN01', value: '' },
        { code: 'LI02', value: '' },
        { code: 'DK03', value: '' },
        { code: 'FT04', value: '' },
        { code: 'RO06', value: '' },
        { code: 'EN11', value: '' },
        { code: 'HB21', value: '' },
        { code: 'AR09', value: '' },
        { code: 'CO18', value: '' },
        { code: 'BR08', value: '' },
        { code: 'OO10', value: '' },
        { code: 'NP19', value: '' },
        { code: 'GE22', value: '' },
        { code: 'VX05', value: '' },
        { code: 'CA24', value: '' },
        { code: 'PR25', value: '' },
        { code: 'DWEB', value: '' },
        { code: 'DMIN', value: '' },
        { code: 'DMAX', value: '' }
    ])
    let fieldsStock = ref([
        { code: 'MN01', value: '' },
        { code: 'LI02', value: '' },
        { code: 'DK03', value: '' },
        { code: 'FT04', value: '' },
        { code: 'RO06', value: '' },
        { code: 'EN11', value: '' },
        { code: 'HB21', value: '' },
        { code: 'AR09', value: '' },
        { code: 'CO18', value: '' },
        { code: 'BR08', value: '' },
        { code: 'OO10', value: '' },
        { code: 'NP19', value: '' },
        { code: 'GE22', value: '' },
        { code: 'VX05', value: '' },
        { code: 'CA24', value: '' },
        { code: 'PR25', value: '' },
        { code: 'DWEB', value: '' },
        { code: 'DEPO', value: '' },
        { code: 'RLQ', value: '' },
    ])
    function repartLigne(repart){
        let ligne=''
        for(let etab in repart){
            if(repart[etab]>0){
                ligne=ligne+`${etab.substring(0,2)}:${repart[etab]},`
            }
            
        }
        return ligne
    }
    let achat=ref({})
    // let achat=ref({
    //     title:{
    //         libelle:'BON DE COMMANDE',
    //         saison:'SPRING - SUMMER 2026',
    //         dateModif:'2025-09-25'
    //     },
    //     fournisseur:{
    //         date:'2025-10-01',
    //         nomClient:'Test',
    //         codeClient:'code_test',
    //         agent:'agent_test',
    //         codeAgent:'code_agent',
    //         libCommande:'testcommande',
    //         etablissement:'NEGO'
    //     },
    //     client:{
    //         enseigne:'enseigne',
    //         raisonSociale:'test',
    //         tvaSiret:'TVA_TEST',
    //         dateLivraison:'2025-10-15',
    //         adresseLiv:'Adresse liv',
    //         adresseFac:'Adresse Fac',
    //         contact:'contact_test',
    //         email:'emailtest',
    //         telephone:'0769',
    //         siteweb:'site',
    //         remarque:'Remarque'
    //     },
    //     fraisPort:20,
    //     remisePied1:10,
    //     remisePied2:0,
    //     articles:{
    //         "903060": {
    //             "231": {
    //               "AA060": {
    //                 "350-2158-424": {
    //                   "1000006315640": {
    //                     "ETABLISSEMENT": "DEPO",
    //                     "SAISON": "PRP",
    //                     "TYPE_COMMANDE": "ATT",
    //                     "CODEpole": "BUS",
    //                     "pole": "Pôle Business",
    //                     "acheteur": "JASPER",
    //                     "code_marque": "231",
    //                     "marque": "ARTHUR & ASTON",
    //                     "CODERAYON": "H",
    //                     "RAYON": "HOMME",
    //                     "CODEFAMILLE": "H2",
    //                     "FAMILLE": "PETITE MAROQUINERIE",
    //                     "SOUSFAMILLE": "PORTEFEUILLE",
    //                     "CODEtheme": "AA060",
    //                     "theme": "MARCO",
    //                     "codearticle": "350-2158-424",
    //                     "designation": "Portefeuille",
    //                     "CODEFOURN": "2158-424",
    //                     "CODEcouleur": "1RI",
    //                     "couleur": "CHATAIGNE",
    //                     "CODEtaille": "",
    //                     "taille": "",
    //                     "CODEABARRE": "1000006315640",
    //                     "EAN13": "3555030176081",
    //                     "code_fournisseur": "903060",
    //                     "fournisseur": "LIBELLE_903060",
    //                     "QUANTITEPROP": "20",
    //                     "achat_euro": "30.5",
    //                     "promo": {base: 0, promo: 0, code: ''},
    //                     "remise_pied":0,
    //                     "remise_ligne":0,
    //                     "stock_DEPO":0,
    //                     "frais_port": 5
    //                   },
    //                   "1000006315626": {
    //                     "ETABLISSEMENT": "DEPO",
    //                     "SAISON": "PRP",
    //                     "TYPE_COMMANDE": "ATT",
    //                     "CODEpole": "BUS",
    //                     "pole": "Pôle Business",
    //                     "acheteur": "JASPER",
    //                     "code_marque": "231",
    //                     "marque": "ARTHUR & ASTON",
    //                     "CODERAYON": "H",
    //                     "RAYON": "HOMME",
    //                     "CODEFAMILLE": "H2",
    //                     "FAMILLE": "PETITE MAROQUINERIE",
    //                     "SOUSFAMILLE": "PORTEFEUILLE",
    //                     "CODEtheme": "AA060",
    //                     "theme": "MARCO",
    //                     "codearticle": "350-2158-424",
    //                     "designation": "Portefeuille",
    //                     "CODEFOURN": "2158-424",
    //                     "CODEcouleur": "01C",
    //                     "couleur": "noir",
    //                     "CODEtaille": "",
    //                     "taille": "",
    //                     "CODEABARRE": "1000006315626",
    //                     "EAN13": "3555030176067",
    //                     "code_fournisseur": "903060",
    //                     "fournisseur": "LIBELLE_903060",
    //                     "QUANTITEPROP": "20",
    //                     "achat_euro": "30.5",
    //                     "promo": {base: 0, promo: 0, code: ''},
    //                     "remise_pied":0,
    //                     "remise_ligne":0,
    //                     "stock_DEPO":0,
    //                     "frais_port": 5
    //                   }
    //                 },
    //                 "350-2158-126": {
    //                   "1000006315589": {
    //                     "ETABLISSEMENT": "DEPO",
    //                     "SAISON": "PRP",
    //                     "TYPE_COMMANDE": "ATT",
    //                     "CODEpole": "BUS",
    //                     "pole": "Pôle Business",
    //                     "ACHATEUR": "JASPER",
    //                     "code_marque": "231",
    //                     "marque": "ARTHUR & ASTON",
    //                     "CODERAYON": "H",
    //                     "RAYON": "HOMME",
    //                     "CODEFAMILLE": "H2",
    //                     "FAMILLE": "PETITE MAROQUINERIE",
    //                     "SOUSFAMILLE": "PORTEFEUILLE",
    //                     "CODEtheme": "AA060",
    //                     "theme": "MARCO",
    //                     "codearticle": "350-2158-126",
    //                     "designation": "Portefeuille",
    //                     "CODEFOURN": "2158-126",
    //                     "CODEcouleur": "1RI",
    //                     "couleur": "CHATAIGNE",
    //                     "CODEtaille": "",
    //                     "taille": "",
    //                     "CODEABARRE": "1000006315589",
    //                     "EAN13": "3555030176029",
    //                     "code_fournisseur": "903060",
    //                     "fournisseur": "LIBELLE_903060",
    //                     "QUANTITEPROP": "20",
    //                     "achat_euro": "30.5",
    //                     "promo": {base: 0, promo: 0, code: ''},
    //                     "remise_pied":0,
    //                     "remise_ligne":0,
    //                     "stock_DEPO":0,
    //                     "frais_port": 5
    //                   }
    //                 }
    //               }
    //             }
    //         }
    //     },

    //     signature:{exist:false,link:'',file:''}

    // })
    let repartEdited=ref([])
    function setRepart(){
       
        if(articleRepart.value.type=='ref'){
            for(let cab in achat.value.articles[articleRepart.value.art.refinterne][articleRepart.value.art.code_marque][articleRepart.value.art.code_theme][articleRepart.value.art.codearticle]){
            achat.value.articles[articleRepart.value.art.refinterne][articleRepart.value.art.code_marque][articleRepart.value.art.code_theme][articleRepart.value.art.codearticle][cab].repart=
            articleRepart.value.art.repart
            repartEdited.value.push(articleRepart.value.art)
            }
        }else{
            for(let cab in achat.value.articles[articleRepart.value.art.refinterne][articleRepart.value.art.code_marque][articleRepart.value.art.code_theme][articleRepart.value.art.codearticle]){
            if(achat.value.articles[articleRepart.value.art.refinterne][articleRepart.value.art.code_marque][articleRepart.value.art.code_theme][articleRepart.value.art.codearticle][cab].code_couleur==articleRepart.value.art.code_couleur)
                {
                    achat.value.articles[articleRepart.value.art.refinterne][articleRepart.value.art.code_marque][articleRepart.value.art.code_theme][articleRepart.value.art.codearticle][cab].repart=
                    articleRepart.value.art.repart
                    repartEdited.value.push(articleRepart.value.art)
                }
            }
        }
        
    }
    function getOrderStatus(refinterne){
        let statut=itemsCommandesFourn.value.find(el=>el.refinterne==refinterne)
        let result ={
            statut:'📝 En Saisie',
            color:{
                color:'black'
            },
            date:''
        }
        if (statut) {
            switch (statut.statut) {
                case 'IMPORTED': 
                result ={
                    statut:`✅ Importé le ${statut.datemodif.split('T')[0]} - Numéro Y2 : ${statut.numero_y2}`,
                    color:{
                        color:'blue'
                    },
                    date:statut.datemodif.split('T')[0],
                    numero:statut.numero_y2
                }
                    
                break;
                case 'INTRANSIT': 
                result ={
                    statut:`🔄 En cours - Numéro Y2 : ${statut.numero_y2} reliquat :${statut.totalqtereste} `,
                    color:{
                        color:'orange'
                    },
                    date:statut.datemodif.split('T')[0],
                    numero:statut.numero_y2
                }
                    
                break;
                case 'DELIVERED': 
                result ={
                    statut:`📦 Livré le ${statut.datemodif.split('T')[0]} - Numéro Y2 : ${statut.numero_y2}`,
                    color:{
                        color:'green'
                    },
                    date:statut.datemodif.split('T')[0],
                    numero:statut.numero_y2
                }
                    
                break;
                case 'DELETED': 
                result ={
                    statut:`❌ Supprimé le ${statut.datemodif.split('T')[0]} - Numéro Y2 : ${statut.numero_y2}`,
                    color:{
                        color:'red'
                    },
                    date:statut.datemodif.split('T')[0],
                    numero:statut.numero_y2
                }
                    
                break;
                default:
                result ={
                    statut:'📝 En Saisie',
                    color:{
                        color:'black'
                    },
                    date:''
                }
                break;
            }
        }
        
        return result
    }
    
    function getLibelleFournisseur(element,niv) {
      // Parcours de l'objet imbriqué jusqu'au champ fournisseur
      const niveau1 = Object.values(element)[0]; // "231"
      const niveau2 = Object.values(niveau1)[0];       // "AA060"
      const niveau3 = Object.values(niveau2)[0];       // "350-2158-424"
      const niveau4 = Object.values(niveau3)[0];
      const niveau5 = Object.values(niveau4)[0];
      if(niv==1){
        return niveau5
      }else{
        return niveau4
      }
             return niv==1?niveau5:niveau4;
    //   return niveau4
    }
    let valid=ref(true)


    const flattenArticles = (data) => {
      const rows = [];

    //   for (const fournisseur in data) {
        for (const codemarque in data) {
          for (const codeTheme in data[codemarque]) {
            for (const codeArticle in data[codemarque][codeTheme]) {
              for (const codeAbarre in data[codemarque][codeTheme][codeArticle]) {
                const article = {
                    Date: data[codemarque][codeTheme][codeArticle][codeAbarre].date,
                    Marque: data[codemarque][codeTheme][codeArticle][codeAbarre].marque,
                    Theme:data[codemarque][codeTheme][codeArticle][codeAbarre].theme,
                    Reference_fournisseur:data[codemarque][codeTheme][codeArticle][codeAbarre].ref_fourn,
                    Couleur:data[codemarque][codeTheme][codeArticle][codeAbarre].couleur,
                    Ean13_Y2: data[codemarque][codeTheme][codeArticle][codeAbarre].ean13_y2,
                    Qte_commande:data[codemarque][codeTheme][codeArticle][codeAbarre].qte_commande,
                    Prix_Achat_Euro: data[codemarque][codeTheme][codeArticle][codeAbarre].achat_euro,
                    Remise_Pied:data[codemarque][codeTheme][codeArticle][codeAbarre].remise_pied,
                    Remise_Ligne: data[codemarque][codeTheme][codeArticle][codeAbarre].remise_ligne
                }
                rows.push(article);
              }
            }
          }
        }
    //   }

      return rows;
    };
    function getCurrentDateYYYYMMDD() {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0'); // Mois commence à 0
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}${month}${day}`;
    }
    function gererateEAN13(cab){

        let ean=Number(cab)
        let ean13=ean.toString().substring(0,12)
        let c=Number(ean13[0])+Number(ean13[2])+Number(ean13[4])+Number(ean13[6])+Number(ean13[8])+Number(ean13[10])
        let b= 3*(Number(ean13[1])+Number(ean13[3])+Number(ean13[5])+Number(ean13[7])+Number(ean13[9])+Number(ean13[11]))
        let cle=(10-(b+c)%10)%10
        return ean13+cle.toString()!=cab&&cab!=''?{erreur:true,color:'red'}: {erreur:false}
    }

    const exportToExcel = (fabricant) => {
        const flatData = flattenArticles(fabricant);

        // Créer la feuille de calcul
        const worksheet = XLSX.utils.json_to_sheet(flatData);
        
        // Définir le style pour les en-têtes
        const headerStyle = {
            font: {
            bold: true,
            color: { rgb: "FFFFFF" } // Texte blanc
            },
            fill: {
            fgColor: { rgb: "4472C4" } // Fond bleu (vous pouvez changer la couleur)
            },
            alignment: {
            horizontal: "center",
            vertical: "center"
            }
        };

        // Obtenir la plage des cellules de la feuille
        const range = XLSX.utils.decode_range(worksheet['!ref']);
        
        // Appliquer le style à la première ligne (en-têtes)
        for (let C = range.s.c; C <= range.e.c; ++C) {
            const cellAddress = XLSX.utils.encode_cell({ r: 0, c: C });
            
            if (!worksheet[cellAddress]) continue;
            
            // Ajouter le style à la cellule d'en-tête
            worksheet[cellAddress].s = headerStyle;
            
            // Optionnel: Ajuster la largeur des colonnes
            if (!worksheet['!cols']) worksheet['!cols'] = [];
            worksheet['!cols'][C] = { wch: 15 }; // Largeur de 15 caractères
        }

        // Créer le classeur et ajouter la feuille
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(
            workbook, 
            worksheet, 
            `${getLibelleFournisseur(fabricant,2).marque}_${getLibelleFournisseur(fabricant,2).code_fournisseur}_${getLibelleFournisseur(fabricant,2).code_marque}`
        );

        // Télécharger le fichier
        XLSX.writeFile(
            workbook, 
            `${getLibelleFournisseur(fabricant,2).marque}_${getLibelleFournisseur(fabricant,2).code_fournisseur}_${getLibelleFournisseur(fabricant,2).code_marque}_${getCurrentDateYYYYMMDD()}.xlsx`
        );
    };
    
    const state = reactive({
        count: 0,
        option: {
            penColor: "rgb(0, 0, 0)",
            backgroundColor: "rgb(255,255,255)"
            },
            disabled: false
        })
    // Enregistrer les composants de Chart.js nécessaires
    ChartJS.register(Title, Tooltip, Legend, ArcElement)

    // Données du graphique
    
    function chartData(marque){
        let labels= chartData1(marque).tabTheme
        let datasets= [
            {
                label: 'Qté',
                backgroundColor: chartData1(marque).colorTab,
                data: chartData1(marque).tabQte,
            },
        ]
        return {
            labels:labels,
            datasets:datasets
        }
    }
    let repartDialog=ref(false)
    let articleRepart=ref()
    let articleStock=ref()
    // Options du graphique
    const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'right', // 👈 Légendes à droite
                labels: {
                    usePointStyle: true,
                    color:'black'
                },
                
            }
            ,
            title: {
                display: true,
                text: 'Répartition par thème',
                color:'black'
            },
        },
    
    } 
     
    const signature1 = ref(null)
    let colorFilter=ref()
    let authorized=ref(false)
    let tab=ref()
    let dialogAjout=ref(false)
    const panel = ref(null)
    const readonly = ref(false)
    let rechercherArticle=ref()
    let rechercherArticleStatut=ref({statut:false,msg:''})
    let duppliquerArticleStatut=ref({statut:false,msg:''})
    let duppliquerArticle=ref()
    
    let newColor=ref({code_couleur:'',couleur:''})
    let noOrderGetted=ref(false)


        
    let collections=ref(['E23','E24','E25','E26','H23','H24','H25','H26','R23','R24','R25','R26'])
    let articleToAdd=ref()
    function getColorNumber(ref){
        let color=[]
        let taille=[]
        for(let cab in ref){
            color.push(ref[cab].couleur)
            taille.push(ref[cab].taille)
        }
        return {color:color.length,taille:taille.length}
    }
    const loading = ref(false)
    function addArticle(){

      for(let art in articleToAdd.value){
        if(articleToAdd.value[art].qte_commande){
            if(!achat.value.articles[fournisseur.value][store.state.marque][articleToAdd.value[art].code_theme]){
                achat.value.articles[fournisseur.value][store.state.marque]={
                    ...achat.value.articles[fournisseur.value][store.state.marque],
                    [articleToAdd.value[art].code_theme]: achat.value.articles[fournisseur.value][store.state.marque][articleToAdd.value[art].code_theme]=
                    {...achat.value.articles[fournisseur.value][store.state.marque][articleToAdd.value[art].code_theme],
                        [articleToAdd.value[art].reference_y2]:{
                            [articleToAdd.value[art].codebarre]:articleToAdd.value[art]
                        }
                    }
                }
                
            }else if(!achat.value.articles[fournisseur.value][store.state.marque][articleToAdd.value[art].code_theme][articleToAdd.value[art].reference_y2]){               
                achat.value.articles[fournisseur.value][store.state.marque][articleToAdd.value[art].code_theme]=
                {...achat.value.articles[fournisseur.value][store.state.marque][articleToAdd.value[art].code_theme],
                    [articleToAdd.value[art].reference_y2]:{
                        [articleToAdd.value[art].codebarre]:articleToAdd.value[art]
                    }
                }
            }else if(!achat.value.articles[fournisseur.value][store.state.marque][articleToAdd.value[art].code_theme][articleToAdd.value[art].reference_y2][articleToAdd.value[art].codebarre]){             
                achat.value.articles[fournisseur.value][store.state.marque][articleToAdd.value[art].code_theme][articleToAdd.value[art].reference_y2]=
                {...achat.value.articles[fournisseur.value][store.state.marque][articleToAdd.value[art].code_theme][articleToAdd.value[art].reference_y2],
                    [articleToAdd.value[art].codebarre]:articleToAdd.value[art]
                }
            }
        }
      }
    }
    let qteStatut=ref(false)
    let ean13Statut=ref(false)
    let articleToAddTab=ref([])


    function calculQte(){
        let articleToAddqte=0
        for(let art in articleToAddTabFilter.value){
            for(let date in store.state.dateLivraisons)
            {
                articleToAddqte+=articleToAddTabFilter.value[art][store.state.dateLivraisons[date]].qte
            }
        }
        return {
            qte:articleToAddqte,
            statut:articleToAddqte>0?true:false
        } 
    }
    function calculQteColor(color){
        let articleToAddqte=0
        for(let date in store.state.dateLivraisons)
        {
            articleToAddqte+=color[store.state.dateLivraisons[date]].qte
        }
        return {
            qte:articleToAddqte,
            statut:articleToAddqte>0?true:false
        } 
    }
    let checkingEan13Statut=ref({statut:false,msg:''})
    function checkingEan13(color){
        let ean=ean13Tab.value.filter(el=>el.ean13_y2==color.ean13_y2 && el.codebarre!=color.codebarre)        
        if(ean.length>0){
            checkingEan13Statut.value.statut=true
            checkingEan13Statut.value.msg=`le EAN13 ${ean[0].ean13_y2} est déjà attribué à la référence: ${ean[0].codearticle} couleur: ${ean[0].code_couleur}-${ean[0].couleur}${ean[0].taille?' taille :'+ean[0].taille:''}`
            return checkingEan13Statut.value
        }
        return {statut:false,msg:''} 
    }
    function checkingEAN13(cab){
        let ean=cab
        let ean13=ean.toString().substring(0,12)
        let c=Number(ean13[0])+Number(ean13[2])+Number(ean13[4])+Number(ean13[6])+Number(ean13[8])+Number(ean13[10])
        let b= 3*(Number(ean13[1])+Number(ean13[3])+Number(ean13[5])+Number(ean13[7])+Number(ean13[9])+Number(ean13[11]))
        let cle=(10-(b+c)%10)%10
        return ean13+cle.toString()!=cab&&cab!=''?{erreur:true,color:'red'}: {erreur:false}
    }
    let autoEAN13=ref(100000000000)
    // articleToAddTabFilter
    function generateEAN13(cab){
        let ean=Number(cab)
        let ean13=ean.toString().substring(0,12)
        let c=Number(ean13[0])+Number(ean13[2])+Number(ean13[4])+Number(ean13[6])+Number(ean13[8])+Number(ean13[10])
        let b= 3*(Number(ean13[1])+Number(ean13[3])+Number(ean13[5])+Number(ean13[7])+Number(ean13[9])+Number(ean13[11]))
        let cle=(10-(b+c)%10)%10
        return ean13+cle.toString()
    }

    let articleRef=ref()
    let newRef=ref()
    function selectArticle(theme,codeArticle){
        rechercher.value=''
        rechercherArticleStatut=ref({statut:false,msg:''})
        if(codeArticle){
            articleToAddTab.value=[]
            tab.value="one"
            for(let art in store.state.articles[store.state.marque][theme][codeArticle]){
                if(!achat.value.articles[fournisseur.value][store.state.marque][theme]){
                    store.state.articles[store.state.marque][theme][codeArticle][art]={
                        ...store.state.articles[store.state.marque][theme][codeArticle][art],
                        date: articleRef.value.date,
                        saison: articleRef.value.saison,
                        refinterne: articleRef.value.refinterne,
                        type_commande: articleRef.value.type_commande,
                        code_fournisseur: articleRef.value.code_fournisseur,
                        etablissement: articleRef.etablissement,
                        codearticle: store.state.articles[store.state.marque][theme][codeArticle][art].reference_y2,
                        qte_commande:0,
                        promo: {base: 0, promo: 0, code: ''},
                        remise_pied:articleRef.value.remise_pied,
                        remise_ligne:0,
                        stock_DEPO:store.state.articles[store.state.marque][theme][codeArticle][art].stock.DEPO?store.state.articles[store.state.marque][theme][codeArticle][art].stock.DEPO:0,
                        frais_port: 0
                        }
                        articleToAddTab.value.push(store.state.articles[store.state.marque][theme][codeArticle][art])
                }else{
                    if(!achat.value.articles[fournisseur.value][store.state.marque][theme][codeArticle]){
                    store.state.articles[store.state.marque][theme][codeArticle][art]={
                        ...store.state.articles[store.state.marque][theme][codeArticle][art],
                        date: articleRef.value.date,
                        saison: articleRef.value.saison,
                        refinterne: articleRef.value.refinterne,
                        type_commande: articleRef.value.type_commande,
                        code_fournisseur: articleRef.value.code_fournisseur,
                        etablissement: articleRef.value.etablissement,
                        codearticle: store.state.articles[store.state.marque][theme][codeArticle][art].reference_y2,
                        qte_commande:0,
                        promo: {base: 0, promo: 0, code: ''},
                        remise_pied:articleRef.value.remise_pied,
                        remise_ligne:0,
                        stock_DEPO:store.state.articles[store.state.marque][theme][codeArticle][art].stock.DEPO?store.state.articles[store.state.marque][theme][codeArticle][art].stock.DEPO:0,
                        frais_port: 0
                        }
                        articleToAddTab.value.push(store.state.articles[store.state.marque][theme][codeArticle][art])
                    }else{
                        if(!achat.value.articles[fournisseur.value][store.state.marque][theme][codeArticle][art]){
                            store.state.articles[store.state.marque][theme][codeArticle][art]={
                                ...store.state.articles[store.state.marque][theme][codeArticle][art],
                                date: articleRef.value.date,
                                saison: articleRef.value.saison,
                                refinterne: articleRef.value.refinterne,
                                type_commande: articleRef.value.type_commande,
                                code_fournisseur: articleRef.value.code_fournisseur,
                                etablissement: articleRef.value.etablissement,
                                codearticle: store.state.articles[store.state.marque][theme][codeArticle][art].reference_y2,
                                qte_commande:0,
                                promo: {base: 0, promo: 0, code: ''},
                                remise_pied:articleRef.value.remise_pied,
                                remise_ligne:0,
                                stock_DEPO:store.state.articles[store.state.marque][theme][codeArticle][art].stock.DEPO?store.state.articles[store.state.marque][theme][codeArticle][art].stock.DEPO:0,
                                frais_port: 0
                                }
                            articleToAddTab.value.push(store.state.articles[store.state.marque][theme][codeArticle][art])
                        }  
                    }
                }  
            }
            articleToAdd.value= store.state.articles[store.state.marque][theme][codeArticle]
            articleToAddTabFilter.value=articleToAddTab.value
          
        }else{
            if(theme){
                articleToAddTab.value=[]
                tab.value="two"
                articleToAdd.value= store.state.articles[store.state.marque][theme]
                for(let ref in store.state.articles[store.state.marque][theme]  ){
                    if(!achat.value.articles[fournisseur.value][store.state.marque][theme]){
                        articleToAddTab.value.push({code:ref,libelle:store.state.articles[store.state.marque][theme][ref][Object.keys(store.state.articles[store.state.marque][theme][ref])[0]].designation,theme:store.state.articles[store.state.marque][theme][ref][Object.keys(store.state.articles[store.state.marque][theme][ref])[0]].code_theme})
                    }else{
                        if(!achat.value.articles[fournisseur.value][store.state.marque][theme][ref]){
                          articleToAddTab.value.push({code:ref,libelle:store.state.articles[store.state.marque][theme][ref][Object.keys(store.state.articles[store.state.marque][theme][ref])[0]].designation,theme:store.state.articles[store.state.marque][theme][ref][Object.keys(store.state.articles[store.state.marque][theme][ref])[0]].code_theme})  
                        }
                    }
                }
                articleToAddTabFilter.value=articleToAddTab.value
            }
            else{            
                articleToAddTab.value=[]
                tab.value="three"
                articleToAdd.value= store.state.articles[store.state.marque]
                for(let th in store.state.articles[store.state.marque] ){
                    if(!achat.value.articles[fournisseur.value][store.state.marque][th]){
                        articleToAddTab.value.push({code:th,libelle:store.state.articles[store.state.marque][th][Object.keys(store.state.articles[store.state.marque][th])[0]][Object.keys(store.state.articles[store.state.marque][th][Object.keys(store.state.articles[store.state.marque][th])[0]])[0]].theme})
                    }
                }
                articleToAddTabFilter.value=articleToAddTab.value
            }
        }
    }
    
    let colorsToAddTab=ref([])
    let colorsToAddTabFilter=ref([])
    let colorsToAddTabFilterSelected=ref([])

    async function getReliquat(article){
        let config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: `/cegid-api/Y2/98661025_001_PROD/api/inventory-quantities/v1?storeIds=DEPO&barcodes=${article.codebarre}&fields=Quantities`, //
            
            
            headers: { 
                'Authorization': `Bearer ${store.state.token_y2}`, 
                'Content-Type': 'application/json'
            }
        };
        axios.request(config)
        .then((response) => {
            stockDialog.value=true
            articleStock.value.art.stock.RLQ=response.data[0].stores[0].warehouses[0].quantities.supplierOrderQuantity
        })
        .catch((error) => {
        //console.log(error);
        })  
        
    }
    // async function getRepart(article){
    //     let config = {
    //         method: 'get',
    //         maxBodyLength: Infinity,
    //         url: `/cegid-api/Y2/98661025_001_PROD/api/inventory-quantities/v1?barcodes=${article.codebarre}&fields=Replenishment'`, //
            
            
    //         headers: { 
    //             'Authorization': `Bearer ${store.state.token_y2}`, 
    //             'Content-Type': 'application/json'
    //         }
    //     };
    //     axios.request(config)
    //     .then((response) => {
           
    //         for(let stock in response.data[0].stores){
              
    //             for(let rep in fields.value){
                    
    //                 if(fields.value[rep].code==response.data[0].stores[stock].id){
    //                     // console.log(fields.value[rep].code,response.data[0].stores[stock].id);
    //                     // console.log(response.data[0].stores[stock].warehouses[0].replenishment.minimumInventoryQuantity)
    //                     fields.value[rep].value=response.data[0].stores[stock].warehouses[0].replenishment.minimumInventoryQuantity

    //                 }
    //                 else if(fields.value[rep].code=='DMIN' && response.data[0].stores[stock].id=='DEPO'){
    //                     fields.value[rep].value=response.data[0].stores[stock].warehouses[0].replenishment.minimumInventoryQuantity
    //                 }else if(fields.value[rep].code=='DMAX' && response.data[0].stores[stock].id=='DEPO'){
    //                     fields.value[rep].value=response.data[0].stores[stock].warehouses[0].replenishment.maximumInventoryQuantity
    //                 }
    //             }  
    //         }
    //         // console.log('fields.value',fields.value);
            

    //         // articleStock.value.art.stock.RLQ=response.data[0].stores[0].warehouses[0].replenishment.supplierOrderQuantity
    //     })
    //     .catch((error) => {
    //     //console.log(error);
    //     })  
        
    // }

    async function getRepart(article) {
        try {
            const config = { method: 'get',
                maxBodyLength: Infinity,
                url: `/cegid-api/Y2/98661025_001_PROD/api/inventory-quantities/v1?barcodes=${article.codebarre}&fields=Replenishment`, //
                headers: { 
                    'Authorization': `Bearer ${store.state.token_y2}`, 
                    'Content-Type': 'application/json' 
                }
            }
            const response = await axios.request(config)
            if(!response.data?.[0]?.stores) return;
            // Créer un Map pour accès rapide
            const fieldMap = new Map(fields.value.map(f => [f.code, f]));
            for(const store of response.data[0].stores) {
                const warehouse = store.warehouses?.[0]?.replenishment;
                if(!warehouse) continue;
                if(store.id === 'DEPO') {
                    if(fieldMap.has('DMIN')) fieldMap.get('DMIN').value = warehouse.minimumInventoryQuantity;
                    if(fieldMap.has('DMAX')) fieldMap.get('DMAX').value = warehouse.maximumInventoryQuantity;
                } else if(fieldMap.has(store.id)) {
                    fieldMap.get(store.id).value = warehouse.minimumInventoryQuantity!=0?warehouse.minimumInventoryQuantity:null;
                }
            }
            repartDialog.value=true
            return fields.value;
        } catch(error) {
            console.error('Erreur getRepart:', error);
        }
    }
    watch(store.state.dateLivraisons,()=>{
        for(let date in store.state.dateLivraisons){
            dateObject.value={
                ...dateObject.value,
                [store.state.dateLivraisons[date]]:{qte:0,export:false}
            }
        }
    })
    let refToCreate=ref({msg:'',statut:false})

    let dateObject=ref({})
    let chekingArt=ref({statut:false,msg:''})
    
    

    let articleToDelete=ref()
    
    function totalTheme(params) {
        let qte=0
        let totalht=0
        let totalhtremise=0
        for(let el in params){
            for (let el1 in params[el]){
                qte+=Number(params[el][el1].qte_commande)
                totalht+=Number(params[el][el1].qte_commande)*params[el][el1].achat_euro
                totalhtremise+=(1-Number(params[el][el1].remise_ligne)/100)*Number(params[el][el1].qte_commande)*params[el][el1].achat_euro      
            }
        }
        return {qte:qte,totalht:totalht.toFixed(2),totalhtremise:totalhtremise.toFixed(2)}
    }
    function totalmarque(params) {
        let qte=0
        let totalht=0
        let totalhtremise=0
        for(let el in params){
            for (let el1 in params[el]){
                // (1-params[el1].remise_pied/100)*(1-params[el1].remise_ligne/100)*
                for (let el2 in params[el][el1]){
                    qte+=Number(params[el][el1][el2].qte_commande)
                    totalht+=Number(params[el][el1][el2].qte_commande)*params[el][el1][el2].achat_euro
                    totalhtremise+=(1-Number(params[el][el1][el2].remise_ligne)/100)*Number(params[el][el1][el2].qte_commande)*params[el][el1][el2].achat_euro      
                }
            }
        }
        return {qte:qte,totalht:totalht.toFixed(2),totalhtremise:totalhtremise.toFixed(2)}
    }
    function totalRef(params) {
        let qte=0
        let qteStock=0
        let totalht=0
        let totalhtremise=0
            for (let el1 in params){
                qteStock+=Number(params[el1].stock_DEPO)
                qte+=Number(params[el1].qte_commande)
                totalht+=Number(params[el1].qte_commande)*params[el1].achat_euro
                // (1-params[el1].remise_pied/100)*(1-params[el1].remise_ligne/100)*
                totalhtremise+=(1-params[el1].remise_ligne/100)*Number(params[el1].qte_commande)*params[el1].achat_euro
                            
            }
        return {qte:Number(qte),totalht:totalht.toFixed(2),totalhtremise:totalhtremise.toFixed(2),qteStock:qteStock}
    }

    function updateExportDateQte(params){
        for(let el in params){
            for(let el1 in params[el]){
                for(let el2 in params[el][el1]){
                    for (let el3 in params[el][el1][el2]){
                        params[el][el1][el2][el3].termine=true
                    }
                }
            }
        }
    }
    function totalCommande(params) {
        let totalht=0
        let qte=0
        let totalhtremise=0
        for(let el in params){
            for(let el1 in params[el]){
                for(let el2 in params[el][el1]){
                    for (let el3 in params[el][el1][el2]){
                        if(params[el][el1][el2][el3].qte_commande){
                            qte+=Number(params[el][el1][el2][el3].qte_commande)
                            totalht+=Number(params[el][el1][el2][el3].qte_commande)*params[el][el1][el2][el3].achat_euro
                            totalhtremise+=(1-params[el][el1][el2][el3].remise_pied/100)*(1-params[el][el1][el2][el3].remise_ligne/100)*Number(params[el][el1][el2][el3].qte_commande)*params[el][el1][el2][el3].achat_euro
                        }
                    }
                }
            }
        }
        totalhtremise=getLibelleFournisseur(params,2).frais_port?totalhtremise+Number(getLibelleFournisseur(params,2).frais_port):totalhtremise
        return {
            totalht:totalht.toFixed(2),
            qte:qte,
            totalhtremise:totalhtremise.toFixed(2)
        }
    }
    function updateFraisPortRemise (params,event,champs){
        for(let el in params){
            for(let el1 in params[el]){
                for(let el2 in params[el][el1]){
                    for (let el3 in params[el][el1][el2]){
                        params[el][el1][el2][el3][champs]=event.target.value
                    }
                }
            }
        }
    }
    function chartData1(marque) {
       
        const colorPalette = [
            "#FF6384", "#36A2EB", "#FFCE56", "#4BC0C0", "#9966FF",
            "#FF9F40", "#E7E9ED", "#FF6B6B", "#6BCB77", "#FFD93D",
            "#845EC2", "#D65DB1", "#FF6F91", "#FF9671", "#FFC75F",
            "#F9F871", "#2C73D2", "#0081CF", "#0089BA", "#008E9B",
            "#008F7A", "#B39CD0", "#FFAAA5", "#FCF6BD", "#D0F4DE",
            "#A9DEF9", "#E4C1F9", "#FFCAD4", "#B5EAD7", "#C7CEEA"
        ];  
        let tab=[]
        let colorTab=[]
        let tabQte=[]
        let i=0
        let qte=0
        let params=marque
        for(let el in params){
            tab.push(params[el][Object.keys(params[el])[0]][Object.keys(params[el][Object.keys(params[el])[0]])[0]].theme)
            
            colorTab.push(colorPalette[i])
            i++
            for (let el1 in params[el]){
                for(let el2 in params[el][el1]){
                    qte=qte+Number(params[el][el1][el2].qte_commande)
                } 
            }
            tabQte.push(qte),
            qte=0
        }
        
        return {tabTheme:tab,colorTab:colorTab,tabQte:tabQte}
    }
    let rechercher=ref()
    watch(rechercher,()=>{
        let regex = new RegExp(rechercher.value, "i")
        if(tab.value=='one'){
            articleToAddTabFilter.value=articleToAddTab.value.filter(el=>(`${el.code_couleur}${el.couleur}${el.codebarre}${el.ean13_y2}`).match(regex))
        }else{
            articleToAddTabFilter.value=articleToAddTab.value.filter(el=>(`${el.code}${el.libelle}`).match(regex))
        } 
    })
    let articleToAddTabFilter=ref([])
    function getArticle(){
        for (let theme in store.state.articles[store.state.marque]){
            for(let ref in store.state.articles[store.state.marque][theme]){
                if(ref==rechercherArticle.value){
                    selectArticle(store.state.articles[store.state.marque][theme][ref][Object.keys(store.state.articles[store.state.marque][theme][ref])[0]],theme,ref)
                    rechercherArticle.value=''
                    rechercherArticleStatut.value={statut:false}
                    return
                }
                for(let cab in store.state.articles[store.state.marque][theme][ref]){
                    if(cab==rechercherArticle.value || rechercherArticle.value==store.state.articles[store.state.marque][theme][ref][cab].ean13_y2){                    
                        articleToAdd.value={[cab]:
                            {
                            ...store.state.articles[store.state.marque][theme][ref][cab],qte:1
                            }
                        }
                        for(let date in store.state.dateLivraisons){
                            articleToAdd.value[cab]={
                                ...articleToAdd.value[cab],[store.state.dateLivraisons[date]]:{qte:0,export:false}
                                
                            }
                        }
                        
                        articleToAddTabFilter.value.push(articleToAdd.value[cab])
                        addArticle()
                        dialogAjout.value=false
                        rechercherArticle.value=''
                        rechercherArticleStatut.value={statut:false}
                        return
                    }
                }
            }
        }
        rechercherArticleStatut.value={statut:true,msg:"L'article n'existe pas!"}
    }

    let couleursTab=ref([])
    let taillesToAddTab=ref([])
    let taillesToAddTabFilter=ref([])
    let taillesToAddTabFilterSelected=ref([])
    let ean13Tab=ref([])
    function convertToObject(arr) {
        const obj = {};
        arr.forEach(item => {
            obj[item] = Number(item);
        });
        return obj;
    }
    function convertToNumberObject(arr) {
        const obj = {};
        arr.forEach(item => {
            obj[item] = Number(item);
        });
        return obj;
    }
    async function getArticles(marque){
        // console.log(marque);
        
        colorsToAddTab.value=[]
        colorsToAddTabFilter.value=[]
        colorsToAddTabFilterSelected.value=[]
        taillesToAddTab.value=[]
        taillesToAddTabFilter.value=[]
        taillesToAddTabFilterSelected.value=[]
        store.commit('updateWaiting')
        let params=
        {   
            marques:`{${marque.map(Number).join(',')}}`
        }
        let url=    `https://my.edisac.com/goapi/articlesdeep`
        let config = {
        method: 'get',
        headers: { 
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${store.state.user.token}`   // ⬅️ Ajout du token
        },
        url: url,
        params:params
        };
        return   axios.request(config)
        .then((response) => {
            
            store.commit('addArticles',response.data.articles) 
            taillesToAddTab.value=response.data.taillesToAddTab
            colorsToAddTab.value=response.data.colorsToAddTab
            taillesToAddTabFilter.value=response.data.taillesToAddTab.sort((a,b)=>{ return a.code_taille-b.code_taille})
            colorsToAddTabFilter.value=response.data.colorsToAddTab.sort((a,b)=>{ return a.couleur-b.couleur})
            maxcouleur.value=response.data.maxcouleur
            ean13Tab.value=response.data.ean13Tab
            store.commit('updateWaiting')
        })
        .catch((error) => {
        });
        
    }
    let maxcouleur=ref()

    let numneg=ref()
    let fabricantToValidate=ref()

    async function getColors (){
        let url=    `https://my.edisac.com/api/colors`
        let config = {
        method: 'get',
        headers: { 
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${store.state.user.token}`   // ⬅️ Ajout du token
        },
        url: url,
        };
        return   axios.request(config)
        .then((response) => {
            couleursTab.value=response.data
        })
        .catch((error) => {
        });
    }
    let filtreCommandes=ref({
        saison:'',
        fournisseur:'',
        marque:'',
        rechercher:''
    })
    let filtreCommandesItems=ref({
        saison:[],
        fournisseur:[],
        marque:[]
    })
    let itemsCommandesFournFiltred=ref([])
    watch(filtreCommandes, () => {
        
        // Créer le regex seulement si on a une recherche
        let regexRecherche = null;
        if (filtreCommandes.value.rechercher && filtreCommandes.value.rechercher.trim() !== "") {
            try {
                // Échapper les caractères spéciaux pour le regex
                const escapedSearch = filtreCommandes.value.rechercher.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
                regexRecherche = new RegExp(escapedSearch, "i"); // "i" pour insensible à la casse, pas besoin de "gm" pour .match()
            } catch (error) {
                console.error("Erreur dans l'expression régulière :", error);
                regexRecherche = null;
            }
        }
        
        itemsCommandesFournFiltred.value = itemsCommandesFourn.value.filter(el => {
            // 1. Filtrer par recherche texte
            let matchRecherche = true;
            if (regexRecherche) {
                const texteRecherche = `${el.code_marque}${el.marque}${el.code_fournisseur}${el.fournisseur}${el.utilisateur}`;
                matchRecherche = regexRecherche.test(texteRecherche);
            }
            
            // 2. Filtrer par fournisseur (si spécifié)
            let matchFournisseur = true;
            if (filtreCommandes.value.fournisseur && filtreCommandes.value.fournisseur !== "") {
                const codeFournisseur = filtreCommandes.value.fournisseur.split('-')[0]?.trim();
                matchFournisseur = el.code_fournisseur == codeFournisseur;
            }
            
            // 3. Filtrer par marque (si spécifiée)
            let matchMarque = true;
            if (filtreCommandes.value.marque && filtreCommandes.value.marque !== "") {
                const codeMarque = filtreCommandes.value.marque.split('-')[0]?.trim();
                matchMarque = el.code_marque == codeMarque;
            }
            
            // 4. Filtrer par saison (si spécifiée)
            let matchSaison = true;
            if (filtreCommandes.value.saison && filtreCommandes.value.saison !== "") {
                matchSaison = el.saison == filtreCommandes.value.saison;
            }
            
            return matchRecherche && matchFournisseur && matchMarque && matchSaison;
        });
        
    }, { deep: true });
    let numcommande=ref()
    let addArticles=ref(false)
    async function getCommandeFournisseur(refInterne,marque){
        let url=    `https://my.edisac.com/api/fournisseur`
        let config = {
        method: 'get',
        headers: { 
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${store.state.user.token}`   // ⬅️ Ajout du token
        },
        url: url,
        params:{refInterne:refInterne}
        };
        return   axios.request(config)
        .then((response) => {
        if(response.data.exist){
            achat.value.articles=response.data.articles
            achat.value.file=response.data.file
            panel.value=[0]
            noOrderGetted.value=false
            addArticles.value=true
            getArticles(Array.of(marque))
        }else{
            // fripeNotExist.value=true
        }
        })
        .catch((error) => {
        // console.log(error);
        });
    }
    function getButtonColor(key){
        let result ='btn btn-outline-secondary btn-sm'
        switch (key) {
            case 'IMPORTED': 
             result ='btn btn-outline-primary btn-sm'
                
            break;
            case 'INTRANSIT': 
             result ='btn btn-outline-warning btn-sm'
                
            break;
            case 'DELIVERED': 
             result ='btn btn-outline-success btn-sm'
                
            break;
            case 'DELETED': 
             result ='btn btn-outline-danger btn-sm'
                
            break;
            default:
            result ='btn btn-outline-secondary btn-sm'
            break;
        }
        return result
    }
    async function getCommandeFournisseurs (){
        store.commit('updateWaiting')
        let url=    `https://my.edisac.com/api/fournisseur`
        let config = {
            method: 'get',
            headers: { 
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${store.state.user.token}`   // ⬅️ Ajout du token
            },
            url: url
        };
        return   axios.request(config)
        .then((response) => {
            store.commit('updateWaiting')
            if(response.data.exist){
                articles.value.articles=response.data
                // commandeNotExist.value={exist:true,numero:numcommande.value,new:'old'}
            }
            // else{
            //     router.replace({ path: '/login' }) 
            //     commandeNotExist.value={exist:true,numero:numnegtoget,new:'rien'}
            // }
        })
        .catch((error) => {
        // console.log(error);
        });
    }
    async function getCurrencyRates(){
        let url=    "https://currencyapi.nethttps://my.edisac.com/api/v1/rates"
        let params = {
            "key": "18705f65c7b2ca18b60a68541aa202286cd5",
            "base": "USD",
            "output": "JSON"
        }
        let config = {
        method: 'get',
        headers: { 
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${store.state.user.token}`   // ⬅️ Ajout du token
        },
        url: url,
        params:params
        };
        return   axios.request(config)
        .then((response) => {
            
        })
        .catch((error) => {
        // console.log(error);
        });
    }
    let itemsCommandesFourn=ref([])
    async function importExport(){
        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: 'https://my.edisac.com/api/scheduledTasksY2',
            headers: { 
                'Content-Type': 'application/json'
            },
            data: {
                first: 2265,
                second: 222187,
                third: 221345
            }
        }

        return axios.request(config)
        .then((response) => { 
        if(response.data.statut=='ok'){
            importDialog.value=true
        }
        })
        .catch((error) => {
        //console.log(error);
        });
    }
    async function getAchat (){
        dialogSpin.value=true
        let url=    `https://my.edisac.com/api/getachat`
        // let url=    `http://localhost:8282/apimyedisac/getachat`
        let config = {
        method: 'get',
        headers: { 
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${store.state.user.token}`   // ⬅️ Ajout du token
        },
        url: url,
        };
        return   axios.request(config)
        .then((response) => {
            addArticles.value=false
            if(response.data.success){
                achat.value.articles=response.data.data
                noOrderGetted.value=false
                itemsCommandesFourn.value=response.data.commandes
                itemsCommandesFournFiltred.value=itemsCommandesFourn.value
                filtreCommandesItems.value.saison=[...new Set(itemsCommandesFourn.value.map(commande => commande.saison))]
                filtreCommandesItems.value.fournisseur=[...new Set(itemsCommandesFourn.value.map(commande => `${commande.code_fournisseur} - ${commande.fournisseur}`))]
                filtreCommandesItems.value.marque=[...new Set(itemsCommandesFourn.value.map(commande => `${commande.code_marque} - ${commande.marque}`))]
                let marquesItems=(commandes) => [...new Set( Object.values(commandes).flatMap(commande => Object.keys(commande)))]
                if(marquesItems(achat.value.articles).length>0){
                    getArticles(marquesItems(achat.value.articles))
                }
                dialogSpin.value=false
            } else {
                noOrderGetted.value=true
                dialogSpin.value=false
            }
            
        })
        .catch((error) => {
        // console.log(error);
        });
    }
    let sousFamilleTab=ref([])
    async function validerProposition(fabricant){
        updateExportDateQte(fabricant)
        let data = {fabricant:fabricant,repartEdited:repartEdited.value,user:store.state.user,file:achat.value.file}
        let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: 'https://my.edisac.com/api/getachat',
        headers: { 
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${store.state.user.token}`   // ⬅️ Ajout du token
        },
        data : data
        }
        
        return axios.request(config)
        .then((response) => { 
            repartEdited.value=[]
            if(!achat.value.file){
                itemsCommandesFourn.value.push(response.data)
            }
            
        })
        .catch((error) => {
        // console.log(error);
        });
    }
    async function sendCommandeFrep(){
        await sendImages()
        let data = achat.articles 
        let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: 'https://my.edisac.com/api/achatarticles',
        headers: { 
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${store.state.user.token}`   // ⬅️ Ajout du token
        },
        data : data
        }
       
        return axios.request(config)
        .then((response) => { 
            updateExportDateQte()
        })
        .catch((error) => {
        //console.log(error);
        });
    }
    function checkingLogIn(){
        let data = JSON.stringify({
            "username": store.state.user.username,
            "password": mdpSaisie.value
        });

        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: 'https://my.edisac.com/api/login',
            headers: { 
                'Content-Type': 'application/json'
            },
            data : data
        };

        axios.request(config)
        .then((response) => {
            if(response.data.statut=='connected'){
                validerProposition(fabricantToValidate.value)
                authentification.value=false
            }else {
                message.value=`${response.data.name}, le mot de passe n'est pas correcte`
            }
        })
        .catch((error) => {
            //console.log(error);
        });
    }
    let productData=ref(null)
    let storeOptions=ref(null)
    let qteArticle=ref({})
    const getStatsReliquat = async (article) => {
        try {
            qteArticle.value={...article,reference_y2:article.codearticle}
            const config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: `/cegid-api/Y2/98661025_001_PROD/api/inventory-quantities/v1?barcodes=${article.codebarre}&fields=Quantities`,
            headers: {
                'Authorization': `Bearer ${store.state.token_y2}`,
                'Content-Type': 'application/json'
            }
            }
            
            const response = await axios.request(config)
            if (response.data?.length > 0) {
                productData.value = response.data[0]
                //console.log(productData.value)
                storeOptions.value = productData.value.stores.map(store => { return `${store.id}`})
                qteDialog.value=true
            }
        } catch (error) {
            console.error('Erreur:', error)
        } 
    }
    
    onMounted(()=>{
        getAchat()
    })
    
</script>
<style scoped> 
.v-expansion-panel-title{
   height: 10px; 
}
.chart-container {
  width: 300px;    /* Largeur souhaitée */
  height: 200px;   /* Hauteur souhaitée */
  
}

.scroll-box {
  height: 300px;
  overflow-y: auto;
  border: 1px solid #ccc;
  padding: 16px;
}
.iconAdd{
cursor: pointer;
}
.iconAdd:hover{
background-color: orange;
}
.iconAddRef{
cursor: pointer;
}
.iconAddRef:hover{
background-color: orange;
}
.iconaddColor{
cursor: pointer;
}
.iconaddColor:hover{
background-color: orange;
}
.entete.sticky {
  position: sticky;
  top: 0;
  z-index: 2;
  background-color: white;
  
}
.actions-card {
  margin-top: 20px;
}
.summary-card {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.summary-card :deep(.v-card-text) {
  color: white;
}
.summary-table {
  background: rgba(255,255,255,0.1);
  border-radius: 8px;
}

.summary-table td {
  border-bottom: 1px solid rgba(255,255,255,0.2);
  color: white;
}
.placeholder-chart {
  background: rgba(255,255,255,0.1);
  border-radius: 8px;
}
.upload-card {
  background: rgba(255, 255, 255, 0.05);
  border: 2px dashed rgba(255, 255, 255, 0.3);
  border-radius: 15px;
  padding: 2rem;
  text-align: center;
  transition: all 0.3s ease;
}

.upload-card.active {
  border-color: #4CAF50;
  background: rgba(76, 175, 80, 0.1);
}
.glass-card {
  position: relative;
  width: 100%;
  min-height: 250px;

  /* Image de fond */
  /* background-image: url('https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=800&q=80'); */
  background-color:#ccc;
  background-size: cover;
  background-position: center;
  border-radius: 5px;
  /* Optionnel : ombre portée */
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);
  overflow: hidden;
}
/* inset: 0; */
/* couche verre */
.glass-card::before {
  content: "";
  position: absolute;
  
  background: rgba(255, 255, 255, 0.25); /* semi-transparent */
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 12px;
  z-index: 0;
}

/* contenu au-dessus */
.content {
  position: relative;
  z-index: 1;
}
.transparent-background {
  background-color: rgba(255, 255, 255, 0.5); /* blanc à 50% de transparence */
}
.no-orders {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem 2rem;
  text-align: center;
  background-color: #f9fafb;
  border-radius: 12px;
  border: 1px dashed #e5e7eb;
}

.no-orders__icon {
  color: #9ca3af;
  margin-bottom: 1.5rem;
}

.no-orders__icon svg {
  width: 64px;
  height: 64px;
}

.no-orders__title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 0.5rem;
}

.no-orders__message {
  color: #6b7280;
  max-width: 300px;
  line-height: 1.5;
}
.loading-content {
  background: white;
  padding: 40px;
  border-radius: 16px;
  text-align: center;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  
  /* Permet les clics dans le contenu du loader */
  pointer-events: auto !important;
}
</style>